var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEiffelTower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82.763,
    height: 172.279,
    viewBox: "0 0 82.763 172.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 5.922, 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.253,159.719l7.572-1.31a6.074,6.074,0,0,0,4.2-2.795,5.945,5.945,0,0,0-.939-7.339,147.019,147.019,0,0,1-16.658-19.294,5.979,5.979,0,0,0-.059-1.6l-.545-3.144a5.94,5.94,0,0,0-5.711-4.927c-2.767-4.638-5.414-9.6-7.894-14.816A5.905,5.905,0,0,0,44.152,103l-.545-3.15a5.933,5.933,0,0,0-3.366-4.383c-4.4-10.993-7.418-23.112-12.939-45.242L27.047,49.2c-1.59-6.369-3.121-12.734-4.564-18.978a5.927,5.927,0,0,0,1.241-4.756l-.318-1.84a5.9,5.9,0,0,0-.771-2.066l-.045-.26c-.023-.3-.06-.6-.116-.923a10,10,0,0,0-4.4-6.7l-.386-2.225a5.92,5.92,0,0,0-.682-1.9l-.084-.49a5.926,5.926,0,0,0,.322-3.181l-.165-.953A5.941,5.941,0,0,0,10.216.088L7.831.5a5.939,5.939,0,0,0-4.84,6.866l.165.953a5.917,5.917,0,0,0,1.37,2.886l.084.488a5.906,5.906,0,0,0,0,2.023l.387,2.241a10.012,10.012,0,0,0-1.877,7.766c.044.257.1.513.157.761l.06.349A5.908,5.908,0,0,0,3.287,27.1l.318,1.84a5.926,5.926,0,0,0,2.832,4.1C8.428,49.661,8.8,52.786,8.841,53.14c2.976,24.827,4.57,38.512,4.725,47.542a5.927,5.927,0,0,0-1.084,4.554l.545,3.149a5.905,5.905,0,0,0,.2.805,156.331,156.331,0,0,1-2.555,17.355,5.943,5.943,0,0,0-3.449,6.446l.544,3.144a5.986,5.986,0,0,0,.377,1.292s-.031.122-.044.177c-.038.17-.084.336-.129.5-.006.024-.018.072-.024.1A202.514,202.514,0,0,1,.406,161.617a5.945,5.945,0,0,0,1.95,6.9A6.127,6.127,0,0,0,7.123,169.6l7.5-1.3,6.455-1.117a4.229,4.229,0,0,0,3.42-4.706A14.492,14.492,0,0,1,37.971,146.1c7.264-.434,13.541,5.138,15.116,12.013a3.6,3.6,0,0,0,4.084,2.739Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#ffdf00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.413,149.5l-.1-.138c-.364-.506-.935-1.32-1.7-2.437-.174-.262-.37-.547-.569-.849-.559-.842-1.192-1.809-1.882-2.913l-33.414,5.78c-.268,1.192-.538,2.315-.786,3.374-.087.343-.168.675-.243.99-.268,1.088-.525,2.089-.761,3.017-.059.26-.127.513-.2.765a207.813,207.813,0,0,1-7.758,24.1l12.71-2.2A20.236,20.236,0,0,1,61.3,172.149l12.71-2.2a152.234,152.234,0,0,1-17.6-20.449M42.5,138.549l-.186.618,3.134.939-.939,3.134.618.185.939-3.133,3.134.939.185-.618-3.133-.939.939-3.134-.618-.186-.939,3.134Zm-1.68-16.435c-.083-.184-.167-.367-.249-.542-.306-.671-.613-1.35-.911-2.03-.143-.328-.3-.655-.429-.985-5.457-12.577-8.678-25.618-14.886-50.5-2.47-9.9-4.384-18.128-5.662-23.772l-3.863.668c.156,1.3,2.864,23.877,2.981,24.9,3.265,27.235,5,42.023,4.756,51.591-.015.761-.045,1.48-.089,2.177-.023.365-.054.733-.077,1.1-.018.193-.027.392-.044.593l-.07.942,18.94-3.276c-.128-.288-.263-.575-.4-.861m-1.166,9.391-.159.527,2.661.8-.8,2.653.527.159.8-2.662,2.653.8.159-.527-2.661-.8.8-2.653-.527-.159-.8,2.662Zm-.572-2.907.663-1.94,1.95.67.13-.393-1.941-.663.662-1.949-.384-.132-.663,1.941-1.949-.662-.132.385,1.942.672-.663,1.94Zm-11.715-.962-1.581,1.316-1.316-1.581-.317.262,1.316,1.581-1.581,1.316.26.308,1.582-1.307,1.316,1.581.317-.262-1.316-1.581,1.581-1.316Zm-4.484,10.671,2.064-1.855,1.856,2.064.4-.371-1.855-2.056,2.064-1.856-.372-.41-2.056,1.854-1.856-2.065-.41.373,1.855,2.056-2.063,1.864Zm-1.27,8.341,2.43-2.186,2.194,2.428.476-.435-2.186-2.43,2.429-2.185-.436-.485-2.43,2.186-2.185-2.43-.485.437,2.186,2.43-2.43,2.186Z",
    transform: "translate(-3.638 -17.885)",
    fill: "#a76946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.825,176.293l-18.94,3.276a167.053,167.053,0,0,1-3.533,22.693l10.118-1.75.423-18.564,7.241-1.252,6.642,17.341,8.989-1.555a182.314,182.314,0,0,1-10.942-20.189m-14.506,23.48-.476.436-2.194-2.429-2.43,2.186-.438-.484,2.43-2.186-2.185-2.429.484-.437,2.186,2.429,2.43-2.185.436.484-2.429,2.186Zm-1.363-10.366,1.855,2.056-.4.371-1.856-2.064-2.064,1.856-.371-.4,2.064-1.864L29.327,187.3l.409-.372L31.592,189l2.056-1.854.373.409Zm2.014-5.24-.317.261-1.316-1.581-1.583,1.307-.26-.308,1.581-1.316L30.76,180.95l.317-.262,1.316,1.581,1.58-1.316.262.317-1.581,1.315Zm10.056-5,.131-.384,1.949.662.663-1.941.384.132-.662,1.949,1.94.663-.13.393-1.95-.67-.663,1.94-.384-.131.663-1.941Zm3.939,9.628.8-2.653-2.661-.8.159-.527,2.653.8.8-2.661.527.159-.8,2.653,2.661.8-.159.527-2.653-.8-.8,2.661Zm4.707,4.809-.939,3.134-.618-.186.939-3.134-3.134-.939.186-.618,3.134.939.939-3.134.618.186-.94,3.134,3.134.939-.186.618Z",
    transform: "translate(-10.239 -71.203)",
    fill: "#a76946"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.708,
    height: 3.197,
    transform: "translate(17.764 103.755) rotate(-9.814)",
    fill: "#e9a635"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.478,
    height: 3.191,
    transform: "matrix(0.985, -0.17, 0.17, 0.985, 12.503, 131.509)",
    fill: "#e9a635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8,219.044l-39.445,6.823c.235-.922.491-1.924.755-3.007l36.9-6.383c.753,1.112,1.332,1.929,1.695,2.435.031.044.062.088.1.132",
    transform: "translate(-9.029 -87.433)",
    fill: "#3a6664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7,32.826a3,3,0,0,1,.052.551c.011.015,0,.026.006.033l.473,2.735-7.584,1.312-.479-2.768.008,0a3.857,3.857,0,0,1-.128-.537A3.973,3.973,0,0,1,16.5,29.72l.082.477,1.38-.239-.082-.476A3.972,3.972,0,0,1,21.7,32.826",
    transform: "translate(-5.648 -11.907)",
    fill: "#a76946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.668,29.959l-1.379.238-.083-.476a3.874,3.874,0,0,1,.683-.187,3.772,3.772,0,0,1,.7-.051Z",
    transform: "translate(-7.353 -11.908)",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.142,41.15a3.766,3.766,0,0,1-1.986,1.015,3.7,3.7,0,0,1-2.2-.29Z",
    transform: "translate(-7.251 -16.62)",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.4,
    height: 6.144,
    transform: "translate(9.888 12.236) rotate(-9.815)",
    fill: "#e9a635"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.702,
    height: 5.565,
    transform: "translate(9.284 6.693) rotate(-9.83)",
    fill: "#966949"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.419,
    height: 0.968,
    transform: "translate(8.274 5.885) rotate(-9.817)",
    fill: "#e9a635"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.537,
    height: 1.867,
    transform: "translate(8.57 25.624) rotate(-9.817)",
    fill: "#3a6664"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.485,
    height: 1.036,
    transform: "translate(21.863 101.076) rotate(-54.814)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.036,
    height: 11.485,
    transform: "translate(20.604 93.796) rotate(-54.814)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.393,
    height: 0.938,
    transform: "translate(20.111 88.488) rotate(-54.814)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.938,
    height: 10.393,
    transform: "matrix(0.576, -0.817, 0.817, 0.576, 18.971, 81.9)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.37,
    height: 0.575,
    transform: "matrix(0.806, -0.592, 0.592, 0.806, 13.314, 146.612)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.575,
    height: 6.37,
    transform: "matrix(0.806, -0.592, 0.592, 0.806, 13.933, 142.561)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.37,
    height: 0.575,
    transform: "matrix(0.806, -0.592, 0.592, 0.806, 11.852, 153.178)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.575,
    height: 6.37,
    transform: "matrix(0.806, -0.592, 0.592, 0.806, 12.471, 149.127)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.37,
    height: 0.575,
    transform: "translate(10.409 159.741) rotate(-36.314)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.575,
    height: 6.37,
    transform: "matrix(0.806, -0.592, 0.592, 0.806, 11.028, 155.691)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.37,
    height: 0.575,
    transform: "matrix(0.14, -0.99, 0.99, 0.14, 59.981, 152.945)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.575,
    height: 6.37,
    transform: "translate(57.517 149.671) rotate(-81.957)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.37,
    height: 0.575,
    transform: "translate(56.308 147.308) rotate(-81.952)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.575,
    height: 6.37,
    transform: "translate(53.845 144.034) rotate(-81.957)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.37,
    height: 0.575,
    transform: "translate(52.624 141.688) rotate(-81.957)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.575,
    height: 6.37,
    transform: "translate(50.161 138.414) rotate(-81.957)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.566,
    height: 0.863,
    transform: "matrix(0.576, -0.817, 0.817, 0.576, 18.329, 76.313)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.863,
    height: 9.566,
    transform: "translate(17.28 70.249) rotate(-54.813)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.883,
    height: 0.711,
    transform: "matrix(0.576, -0.817, 0.817, 0.576, 16.926, 65.802)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.711,
    height: 7.883,
    transform: "matrix(0.576, -0.817, 0.817, 0.576, 16.062, 60.805)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.012,
    height: 0.632,
    transform: "translate(15.663 56.532) rotate(-54.813)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.632,
    height: 7.012,
    transform: "translate(14.895 52.087) rotate(-54.813)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.391,
    height: 0.577,
    transform: "translate(14.411 47.89) rotate(-54.816)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.577,
    height: 6.391,
    transform: "translate(13.71 43.838) rotate(-54.816)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.464,
    height: 0.493,
    transform: "matrix(0.576, -0.817, 0.817, 0.576, 13.285, 39.281)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.493,
    height: 5.464,
    transform: "matrix(0.576, -0.817, 0.817, 0.576, 12.685, 35.818)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.522,
    height: 0.408,
    transform: "translate(12.393 31.993) rotate(-54.812)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.408,
    height: 4.522,
    transform: "translate(11.897 29.126) rotate(-54.812)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.462,233.1l-1.779,2.492-.227-.158,1.779-2.492Z",
    transform: "translate(-9.878 -94.083)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.409,235.485l-2.513-1.75.16-.225,2.513,1.75Z",
    transform: "translate(-9.652 -94.312)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.217,226.224l-1.779,2.492-.227-.158,1.779-2.492Z",
    transform: "translate(-25.934 -91.306)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.164,228.608l-2.513-1.75.161-.225,2.513,1.75Z",
    transform: "translate(-25.708 -91.535)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.088,231.955l-1.779,2.492-.227-.158,1.779-2.492Z",
    transform: "translate(-12.554 -93.62)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.035,234.338l-2.513-1.75.161-.225,2.513,1.75Z",
    transform: "translate(-12.327 -93.849)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.714,230.809,37.934,233.3l-.227-.158,1.779-2.492Z",
    transform: "translate(-15.23 -93.157)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.661,233.192l-2.513-1.75.161-.225,2.513,1.75Z",
    transform: "translate(-15.003 -93.386)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.34,229.663l-1.779,2.492L44.334,232l1.779-2.492Z",
    transform: "translate(-17.906 -92.694)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.287,232.046l-2.513-1.75.16-.225,2.513,1.75Z",
    transform: "translate(-17.68 -92.923)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.966,228.516l-1.779,2.492-.227-.158,1.779-2.492Z",
    transform: "translate(-20.582 -92.231)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.913,230.9,50.4,229.15l.16-.225,2.513,1.75Z",
    transform: "translate(-20.356 -92.46)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.591,227.37l-1.779,2.492-.227-.158,1.779-2.492Z",
    transform: "translate(-23.258 -91.768)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.538,229.754,57.025,228l.161-.225,2.513,1.75Z",
    transform: "translate(-23.032 -91.997)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.556,222.879l-1.779,2.492-.227-.158,1.779-2.492Z",
    transform: "translate(-33.745 -89.954)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5,225.263l-2.513-1.75.161-.225,2.513,1.75Z",
    transform: "translate(-33.518 -90.184)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3,225.171l-1.779,2.492-.227-.158,1.779-2.492Z",
    transform: "translate(-28.393 -90.88)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.251,227.555l-2.513-1.75.16-.225,2.513,1.75Z",
    transform: "translate(-28.167 -91.109)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.93,224.025l-1.779,2.492-.227-.158,1.779-2.492Z",
    transform: "translate(-31.069 -90.417)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.877,226.409l-2.513-1.75.161-.225,2.513,1.75Z",
    transform: "translate(-30.842 -90.646)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.719,184.428l-1.581,1.316-.317.261-1.583,1.307-.26-.308,1.581-1.316.317-.262,1.581-1.316Z",
    transform: "translate(-13.724 -74.361)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.633,187.145l-.317.261L36,185.825l-.262-.317-1.315-1.581.316-.261,1.316,1.581.261.317Z",
    transform: "translate(-13.904 -74.181)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.572,194.9l-2.065,1.856-.4.362-2.064,1.856-.371-.4,2.064-1.864.41-.364,2.056-1.854Z",
    transform: "translate(-12.791 -78.553)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,198.671l-.4.371-1.856-2.064-.372-.41-1.855-2.056.41-.373,1.856,2.065.364.411Z",
    transform: "translate(-12.932 -78.411)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.208,207.611,32.779,209.8l-.484.436-2.43,2.186-.438-.484,2.43-2.186.484-.437,2.43-2.185Z",
    transform: "translate(-11.885 -83.656)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.13,212.061l-.476.435-2.194-2.428-.437-.484-2.185-2.43.484-.437,2.185,2.43.438.484Z",
    transform: "translate(-12.051 -83.491)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.672,178.464l-.662,1.949-.139.386-.663,1.94-.384-.132.663-1.94.138-.394.663-1.941Z",
    transform: "translate(-23.758 -72.026)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.084,181.943l-.13.393-1.95-.67-.384-.132-1.942-.672.132-.384,1.949.662.386.139Z",
    transform: "translate(-22.891 -72.893)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.557,187.635l-.8,2.653-.151.526-.8,2.661-.527-.159.8-2.653.15-.525.8-2.662Z",
    transform: "translate(-25.56 -75.72)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.158,192.348l-.159.527-2.653-.8-.526-.15-2.661-.8.159-.527,2.653.8.526.15Z",
    transform: "translate(-24.298 -76.982)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.252,198.922l-.939,3.134-.187.618-.939,3.134-.618-.186.939-3.134.186-.618.939-3.134Z",
    transform: "translate(-27.695 -80.267)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.959,204.482l-.186.618-3.134-.939-.618-.186-3.134-.939.186-.618,3.134.939.618.185Z",
    transform: "translate(-26.208 -81.754)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(15.754 135.418) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(18.207 134.993) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(20.796 134.546) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(23.419 134.092) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(25.979 133.649) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(28.432 133.225) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(31.021 132.777) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(33.644 132.323) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(36.131 131.893) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(38.583 131.469) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(41.173 131.021) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(46.507 130.098) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(48.868 129.69) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.653,
    height: 2.147,
    transform: "translate(43.795 130.567) rotate(-9.823)",
    fill: "#bc8264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.219,175.709l-18.94,3.276c.023-.314.046-.628.069-.942l18.472-3.2c.136.287.272.573.4.861",
    transform: "translate(-12.633 -70.619)",
    fill: "#3a6664"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEiffelTower);
export default __webpack_public_path__ + "static/media/eiffel-tower.647c40a6294361d482a3257c81011654.svg";
export { ForwardRef as ReactComponent };